import { createReducer, createActions } from 'reduxsauce'
import _ from 'lodash'
import { TransactionsTypes } from './transactions'

export const { Types: ResourcesTypes, Creators } = createActions({
    //NOTE: Do not pass the keyword "type" as an argument, as it will override the action type name.
    updateResourceProduct: ['body', 'callback'],
    updateResourceProductSuccess: ['updatedResource'],
    updateResourceProductFailure: [],

    updateShopifyResource: ['body', 'callback'],
    updateShopifyResourceSuccess: [],
    updateShopifyResourceFailure: ['updateShopifyResourceError'],

    parseProductsWithShopifyData: ['resources', 'shopifyProducts'],
})

const INITIAL_STATE = {
    resources: [],
    parsedProductsWithShopifyData: [],
    outOfStockLoading: null,

    updateShopifyResourceIdLoading: null,
    updateShopifyResourceError: null,
}

export const reducer = createReducer(INITIAL_STATE, {
    [TransactionsTypes.GET_TRANSACTIONS_SUCCESS]: (state, { resources }) => {
        const resourcesWithParsedProducts = resources.map(resource => ({
            ...resource,
            productsV2: resource?.productsV2.map(product => JSON.parse(product)),
        }))
        return {
            ...state,
            resources: _.uniqWith([...state.resources, ...resourcesWithParsedProducts], _.isEqual),
        }
    },

    [ResourcesTypes.UPDATE_RESOURCE_PRODUCT]: (state, { body }) => ({ ...state, outOfStockLoading: body.productId }),
    [ResourcesTypes.UPDATE_RESOURCE_PRODUCT_SUCCESS]: (state, { updatedResource }) => ({
        ...state,
        resources: state.resources.map(resource =>
            resource.resourceId === updatedResource.resourceId ? { ...resource, ...updatedResource } : resource
        ),
        outOfStockLoading: null,
    }),
    [ResourcesTypes.UPDATE_RESOURCE_PRODUCT_FAILURE]: state => ({ ...state, outOfStockLoading: null }),

    // updateShopifyResource
    [ResourcesTypes.UPDATE_SHOPIFY_RESOURCE]: (state, { body }) => ({ ...state, updateShopifyResourceIdLoading: body.productId }),
    [ResourcesTypes.UPDATE_SHOPIFY_RESOURCE_SUCCESS]: state => ({ ...state, updateShopifyResourceIdLoading: null, updateShopifyResourceError: null }),
    [ResourcesTypes.UPDATE_SHOPIFY_RESOURCE_FAILURE]: (state, { updateShopifyResourceError }) => ({
        ...state,
        updateShopifyResourceIdLoading: null,
        updateShopifyResourceError,
    }),

    // Parse productsV2 & merge Resources with ShopifyProducts
    [ResourcesTypes.PARSE_PRODUCTS_WITH_SHOPIFY_DATA]: (state, { resources, shopifyProducts }) => ({
        ...state,
        parsedProductsWithShopifyData: resources.map(resource => ({
            ...resource,
            productsV2: resource?.productsV2.map(product => (typeof product === 'string' ? JSON.parse(product) : product)),
            shopifyProducts,
        })),
    }),
})

export default Creators
